<template>
    <payment-history @paginate="setPage" @sort="setSort" :loading="isFetching" :sort="sort" :records="paginatedRecords" :total="totalRecords" :display="display" :page="page" />
</template>
<script>
    import { mapActions, mapGetters, mapState } from 'vuex';
    import PaymentHistory from "./PaymentHistory.vue";

    export default {
        name: 'payment-history-container',
        components: {
            PaymentHistory,
        },
        data() {
            return {
                isFetching: true,
            }
        },
        methods: {
            ...mapActions('paymentHistory', [
                'fetchHistory',
                'setPage',
                'setSort',
                'resetState',
            ]),
        },
        computed: {
            ...mapState('paymentHistory', ['page', 'display', 'sort']),
            ...mapGetters('paymentHistory', ['paginatedRecords', 'totalRecords']),
        },
        created() {
            this.fetchHistory()
                .then((res) => {
                    this.isFetching = false;
                })
                .catch((res) => {
                    this.isFetching = false;
                });
        },
        destroyed() {
            this.resetState();
        },
    }
</script>



// WEBPACK FOOTER //
// PaymentHistoryContainer.vue?a4fbb85e